import { mergeClassNames } from '../../../utils/mergeClassNames';
import React from 'react';
import styles from './TypeaheadItem.module.scss';

import { ListBoxItem, ListBoxItemProps } from 'react-aria-components';
import { TypeaheadProps } from './Typeahead';
import { useTypeaheadContext } from './TypeaheadContext';

export type TypeaheadItemProps = ListBoxItemProps & {
  /** A visible description of the item. */
  children: React.ReactNode;
  /**
   * The size of the item. If not provided, `size` is inherited from the parent `Typeahead`.
   */
  size?: TypeaheadProps['size'];
};

/**
 * An individual item to be rendered inside a `Typeahead` popover.
 */
export const TypeaheadItem = ({
  children,
  className,
  id,
  size: sizeFromProps,
  textValue,
  ...props
}: TypeaheadItemProps) => {
  const { size: sizeFromContext } = useTypeaheadContext();

  const childrenIsPureText = React.useMemo(
    () =>
      React.Children.toArray(children).every(
        (child) => typeof child === 'string' || typeof child === 'number'
      ),
    [children]
  );

  if (!childrenIsPureText && !textValue) {
    console.error(
      'TypeaheadItem: The `textValue` prop must be set if `children` is not plain text.'
    );
  }

  return (
    <ListBoxItem
      className={(renderProps) =>
        mergeClassNames([styles.listBoxItem, className], renderProps)
      }
      data-size={sizeFromProps ?? sizeFromContext}
      data-zds
      id={id}
      textValue={textValue}
      {...props}
    >
      {/* TODO: handle children function prop */}
      {children}
    </ListBoxItem>
  );
};
